import React from "react";
import { Select, Textarea } from "../Form";
import { getMessage } from "../../lib/translator";
export default function CancelDialogForm({
  cancellationReasons = [],
  cancelReason,
  cancelMessage,
  onReasonChange = () => {},
  onMessageChange = () => {},
}) {
  const options = (cancellationReasons || []).map((status) => {
    const displayText = status.startsWith("Other:")
      ? status.replace("Other:", "").trim()
      : status;

    return {
      text: getMessage(displayText),
      value: status,
    };
  });

  const isOtherSelected = cancelReason?.startsWith("Other:");
  return (
    <div>
      <p>{getMessage("order.details.cancellation.message")}</p>
      <Select
        label={getMessage("Reason")}
        placeholder={getMessage("Select Reason")}
        name="cancelReason"
        options={options}
        value={cancelReason}
        onChange={onReasonChange}
        required
      />
      {isOtherSelected && (
        <Textarea
          label={getMessage("Add Reason")}
          type="text"
          name="cancelMessage"
          value={cancelMessage}
          onChange={onMessageChange}
          required
        />
      )}
    </div>
  );
}
